import LaunchDarklyGateway from '../lib/LaunchDarklyGateway';
import AnalyticsGateway from '../lib/AnalyticsGateway';

export default function initializeGateways() {
  return () => {
    LaunchDarklyGateway.initialize();
    AnalyticsGateway.initialize();
  };
}